import { User } from "#models/user";
import { UserService } from "#services/api";
import { DateTimeService } from "#services/shared/datetime.service";
import { Component, Input, input, OnDestroy, OnInit } from "@angular/core";
import { finalize, Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-estimate-editor-history",
  templateUrl: "./estimate-editor-history.component.html",
  styleUrl: "./estimate-editor-history.component.scss",
  standalone: false,
})
export class EstimateEditorHistoryComponent implements OnInit, OnDestroy {
  @Input() CreatedBy: string;
  @Input() CreatedDate: Date;
  @Input() UpdatedBy: string;
  @Input() UpdatedDate: Date;

  users: User[];
  createdBy: string;
  modifiedBy: string;

  private destroy$ = new Subject<void>();
  userLoading: boolean;

  constructor(
    private _dateTimeSvc: DateTimeService,
    private _userSvc: UserService,
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this._loadUsers();
  }

  private _loadUsers() {
    this.userLoading = true;
    this._userSvc
      .getUsersandRoles()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.userLoading = false;
        }),
      )
      .subscribe((users: User[]) => {
        this.users = users;

        this.createdBy = this._getUserDisplayName(this.CreatedBy);
        this.modifiedBy = this._getUserDisplayName(this.UpdatedBy);
      });
  }

  private _getUserDisplayName(user: string): string {
    if (
      user.toLowerCase().includes("sp_") ||
      user.toLowerCase().includes("system-migration")
    )
      return "System";

    const userObj = this.users.find(
      (u) => u.Email?.toLowerCase() === user.toLowerCase(),
    );

    return userObj ? `${userObj.FirstName} ${userObj.LastName}` : user;
  }

  getShortDate(date): string {
    return this._dateTimeSvc.getShortDate(date);
  }
}
